import { Injectable } from '@angular/core';

@Injectable()
export class CategoryBoxesCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello");
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/category-boxes/category-boxes.common.ts